import React from 'react'
import SubHeader from '../ui/SubHeader.jsx'


import './styles/UserProfileHeader.scss';

const UserProfileHeader = (props) => <SubHeader title={props.user.name}>

      <br />{props.children}<br /><br />
      <div className="avatar large" style={{backgroundImage: 'url('+props.user.picture+')'}}>

      </div>

  </SubHeader>;

export default UserProfileHeader;



// WEBPACK FOOTER //
// ./src/components/user/UserProfileHeader.jsx